export const DICTIONARY = '/dictionary';
export const PUBLISHER = '/dictionary/publisher/:subjectId/:schoolLevelId';
export const SCHOOLS = '/schools/list';
export const TEACHER = '/teacher';
